module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-left-5.d8863bbc.png";